import { useExcludeAIChatForRoute } from '@ecomm/ai-chat/useExcludeAIChatForRoute'
import { useIsAIChatExperiment } from '@ecomm/ai-chat/useIsAIChatExperiment'

export function useIsAIChatEnabled() {
  const { isVariant, enabled: isChatEnabled } = useIsAIChatExperiment({})
  const isExcludedRoute = useExcludeAIChatForRoute()

  return isChatEnabled && isVariant && !isExcludedRoute
}
